import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'vex-swap-exercise-modal',
  templateUrl: './swap-exercise-modal.component.html',
  styleUrls: ['./swap-exercise-modal.component.scss']
})
export class SwapExerciseModalComponent implements OnInit {
  @Input() exercise: any;
  @Input() exerciseAlternative: any;
  environment = environment.baseURL;
  showSpinner: boolean = true;

  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, public translate: TranslateService) {
   this.exercise = data.exerciseAlternative;
   this.exerciseAlternative = data.exercise;
  }

  ngOnInit() {
    setTimeout(() => {
      this.showSpinner = false;
    }, 2800);
  }

  closeModal(action?){
    this.dialogRef.close(action ? action : null)
  }

}
